const mobileWidth = window.mobWidth || 520;


if (window.innerWidth < mobileWidth) {

const btn = document.getElementById("cta-floating");
const staticCtas = document.querySelectorAll(".has-cta");

// Main observer logic
const observer = new IntersectionObserver((entries) => {
    let isAnyVisible = entries.some(entry => entry.isIntersecting);
    btn.style.display = isAnyVisible ? "none" : "block";
}, {
    threshold: 0.01, // Trigger even when 1% of element is in view
    rootMargin: "0px" // You can increase this if you want earlier detection
});

// Observe all .has-cta elements
staticCtas.forEach(el => observer.observe(el));

// Manual visibility check on initial load
function isAnyStaticCtaVisible() {
    return Array.from(staticCtas).some(el => {
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    });
}

// Run initial check on DOM ready and on load (to catch images/layout shifts)
function updateFloatingCTAVisibility() {
    btn.style.display = isAnyStaticCtaVisible() ? "none" : "block";
}

window.addEventListener("DOMContentLoaded", updateFloatingCTAVisibility);
window.addEventListener("load", updateFloatingCTAVisibility);

            function floaterHeight() {
                var cookieNotif = document.getElementById("cookie-notif") || document.getElementById("risk-floating");
                var ctaFloating = document.getElementById("cta-floating");

                if (cookieNotif && ctaFloating) {

                    var displayStyle = window.getComputedStyle(cookieNotif).display;
                    var footerPadding = document.getElementById("disclaimers_footer");
                    var floaterH = cookieNotif.offsetHeight;
                    footerPadding.style.paddingBottom = (floaterH + 55) + "px";

                    if (displayStyle !== 'none') {
                        var floaterH = cookieNotif.offsetHeight;
                        ctaFloating.style.marginBottom = (floaterH + 15) + "px";
                    } else {
                        ctaFloating.style.marginBottom = "20px";
                    }
                }

                setTimeout(floaterHeight, 500);
            }

            floaterHeight();



    }